import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RazorpayErrorResponse } from '../../services/paymentService.ts';
import './PaymentSuccess.css';

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const errorResponse = location.state?.errorResponse as RazorpayErrorResponse;

  const getErrorMessage = () => {
    if (errorResponse?.error) {
      const error = errorResponse.error;

      switch (error.code) {
        case 'BAD_REQUEST_ERROR':
          return 'Invalid payment request. Please try again.';
        case 'GATEWAY_ERROR':
          return 'Payment gateway error. Please try again later.';
        case 'SERVER_ERROR':
          return 'Server error occurred. Please try again later.';
        case 'NETWORK_ERROR':
          return 'Network connection failed. Please check your internet connection.';
        default:
          return error.description || 'Payment failed. Please try again.';
      }
    }

    return 'Payment was not completed. Please try again.';
  };

  const getErrorDetails = () => {
    if (errorResponse?.error) {
      return {
        code: errorResponse.error.code,
        reason: errorResponse.error.reason,
        step: errorResponse.error.step,
        orderId: errorResponse.error.metadata?.order_id,
        paymentId: errorResponse.error.metadata?.payment_id,
      };
    }
    return null;
  };

  const errorDetails = getErrorDetails();

  return (
    <div className="payment-result-container">
      <div className="payment-result-card error">
        <div className="error-icon">✕</div>
        <h2>Payment Failed</h2>
        <p className="success-message">{getErrorMessage()}</p>

        {errorDetails && (
          <div className="subscription-details">
            <div className="detail-row">
              <span className="label">Error Code:</span>
              <span className="value">{errorDetails.code}</span>
            </div>
            {errorDetails.reason && (
              <div className="detail-row">
                <span className="label">Reason:</span>
                <span className="value">{errorDetails.reason}</span>
              </div>
            )}
            {errorDetails.step && (
              <div className="detail-row">
                <span className="label">Failed At:</span>
                <span className="value">{errorDetails.step}</span>
              </div>
            )}
            {errorDetails.orderId && (
              <div className="detail-row">
                <span className="label">Order ID:</span>
                <span className="value">{errorDetails.orderId}</span>
              </div>
            )}
            {errorDetails.paymentId && (
              <div className="detail-row">
                <span className="label">Payment ID:</span>
                <span className="value">{errorDetails.paymentId}</span>
              </div>
            )}
          </div>
        )}

        <div className="error-info">
          <h3>Common Reasons for Payment Failure:</h3>
          <ul>
            <li>Insufficient balance in your account</li>
            <li>Incorrect card details or OTP</li>
            <li>Payment declined by your bank</li>
            <li>Network connection issues</li>
            <li>Payment gateway timeout</li>
          </ul>
        </div>

        <div className="action-buttons">
          <button onClick={() => navigate('/pricing')} className="btn-primary">
            Try Again
          </button>
          <button onClick={() => navigate('/')} className="btn-secondary">
            Go to Home
          </button>
        </div>

        <div className="support-info">
          <p>
            If you continue to face issues, please contact our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
